<template>
  <div>
    <div class="is-border-top is-border-right is-border-left columns is-gapless is-marginless has-background-light">
      <div class="column">
        <tabs
          :links="tabsSellers"
          :level="2"
          mode="emitter"
          @changeView="tab = $event"
          classes="has-background-light"
          :current-tab="tab"></tabs>
      </div>
      <div
        class="column is-narrow is-border-left is-self-stretched"
        v-if="tab === 'SELECTION'">
        <a
          @click="searchNewEntity()"
          class="button is-radiusless is-small is-light is-minH100 has-text-grey is-uppercase">
          <span class="icon is-small"><i class="fal fa-plus"></i></span>
          <span>Ajouter une Entrée</span>
        </a>
      </div>
      <div
        class="column is-narrow is-border-left is-self-stretched"
        v-if="tab === 'SELECTION'">
        <a
          @click="clearSelection()"
          data-tooltip="Supprimer toute la selection"
          class="tooltip is-tooltip-left button is-radiusless is-light has-text-danger is-square is-uppercase">
          <span class="icon is-small"><i class="fal fa-trash-alt"></i></span>
        </a>
      </div>
    </div>
    <div class="statisticsRows-header statisticsRows-header--sticky is-border-right is-border-left has-background-white">
      <div class="columns is-gapless is-size-7-touch is-size-7-desktop is-size-6-widescreen">
        <div class="column is-2 columns">
          <div class="column is-12 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('name', $event)"
              sort-id="name"
              :current-sort-id="sortKey"
              :sort="sortBy.name"
              label="Entité"></sortable>
          </div>
        </div>
        <div class="column is-6 columns">
          <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('prereservationsCount', $event)"
              sort-id="prereservationsCount"
              :current-sort-id="sortKey"
              :sort="sortBy.prereservationsCount"
              label="Pré-Réservations"></sortable>
          </div>
          <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('reservationsCount', $event)"
              sort-id="reservationsCount"
              :current-sort-id="sortKey"
              :sort="sortBy.reservationsCount"
              label="Réservations"></sortable>
          </div>
          <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('actesCount', $event)"
              sort-id="actesCount"
              :current-sort-id="sortKey"
              :sort="sortBy.actesCount"
              label="Actes"></sortable>
          </div>
          <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('cancelCount', $event)"
              sort-id="cancelCount"
              :current-sort-id="sortKey"
              :sort="sortBy.cancelCount"
              label="Annulation(s)"></sortable>
          </div>
          <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('CA_immo', $event)"
              sort-id="CA_immo"
              :current-sort-id="sortKey"
              :sort="sortBy.CA_immo"
              label="CA"></sortable>
          </div>
          <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('avgCA', $event)"
              sort-id="avgCA"
              :current-sort-id="sortKey"
              :sort="sortBy.avgCA"
              label="Prix de vente Moy."></sortable>
          </div>
        </div>
        <div class="columns column is-4">
          <div class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('COM', $event)"
              sort-id="COM"
              :current-sort-id="sortKey"
              :sort="sortBy.COM"
              label="COM"></sortable>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('avgCOM', $event)"
              sort-id="avgCOM"
              :current-sort-id="sortKey"
              :sort="sortBy.avgCOM"
              label="Com Moy."></sortable>
          </div>
          <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="sort('avgRemuneration', $event)"
              sort-id="avgRemuneration"
              :current-sort-id="sortKey"
              :sort="sortBy.avgRemuneration"
              label="Rémunération Moy."></sortable>
          </div>
          <div class="column is-2">
          </div>
        </div>
      </div>
    </div>
    <div class="statisticsRows-lignes is-size-6-touch is-size-6-desktop is-size-5-widescreen">
      <stats-sellers-row
        v-for="(e) in sortedEntities"
        :entity="e"
        :total-sub-entities="totalSubEntities"
        :is-open="statOpenedEntity && statOpenedEntity.pk === e.pk"
        class="has-background-white is-border is-relative is-margin-bottom-small"
        :key="e.pk"
        @remove="removeEntity"
        @open="openEntity"
        :can-open-row="tab !== 'ACCOUNT'"
        :can-be-remove="tab === 'SELECTION'"></stats-sellers-row>
      <stats-sellers-row
        v-if="statsEntities.length > 0 && totalEntities"
        :entity="totalEntities"
        :is-open="false"
        :is-total="true"
        :can-be-remove="false"
        class="statisticsRows-ligne--synthese"></stats-sellers-row>
    </div>
    <div v-if="tab === 'SELECTION'">
      <a
        @click="searchNewEntity()"
        class="columns is-vcentered is-gapless is-border is-border--primary has-link-grey is-padding-small is-border--dashed is-margin-top-small is-margin-bottom-small">
        <div class="column is-uppercase">Ajouter une entrée</div>
        <div class="column is-narrow"><span><i class="fal fa-plus-square"></i></span></div>
      </a>
    </div>
  </div>
</template>

<script>
import { flatten, uniqBy, intersection } from 'lodash'
import { mapGetters, mapState } from 'vuex'
import { Quickview } from '@/mixins'
import StatsMixins from '../StatsMixins'

export default {
  name: 'StatsSellers',
  components: {
    StatsSellersRow: () => import('./StatsSellersRow')
  },
  mixins: [StatsMixins, Quickview],
  data () {
    return {
      tab: 'SELLERS',
      tabsSellers: [
        { link: 'SELLERS', label: 'Vendeurs' },
        { link: 'TEAM', label: 'Équipes' },
        { link: 'GROUPS', label: 'Groupes' },
        { link: 'ACCOUNT', label: 'Sociétés' },
        { link: 'SELECTION', label: 'Ma Sélection' }
      ],
      entitiesSelection: []
    }
  },
  computed: {
    ...mapState(['quickview']),
    ...mapGetters(['accountPk']),
    // displayed on tab SELLERS
    processedStatsSellers () {
      let statsSales = this.statsSales.filter(x => x.user && x.account.pk === this.accountPk)
      const entityNameGenerator = sale => `${sale.user.first_name} ${sale.user.last_name}`
      return this.processSellersDatas(this.computeEntityData(statsSales, 'user.pk', 'user', entityNameGenerator))
    },
    // displayed on tab SELECTION
    processedStatsSellersSelection () {
      let type = 'user'
      let statsSales = []
      let resultToCompute = []
      const entityNameGenerator = sale => sale.account && sale.account.pk !== this.accountPk ? sale.account.name : sale.user && sale.user.last_name ? `${sale.user.first_name} ${sale.user.last_name}` : (sale.name || sale.user_name)
      this.entitiesSelection.forEach(entity => {
        const users = this.statsSales.slice().filter(x => x.user && x.user.pk === entity.pk)
        const accounts = this.statsSales.slice().filter(x => x.account && x.account.pk === entity.pk)
        if (accounts && accounts.length) {
          type = 'account'
          statsSales = [...statsSales, ...accounts]
        } else {
          type = 'user'
          if (users && users.length) {
            statsSales = [...statsSales, ...users]
          } else {
            statsSales = [...statsSales, ...users, { ...entity, user: entity }]
          }
        }
        resultToCompute = [...resultToCompute, ...this.computeEntityData(statsSales, null, type, entityNameGenerator)]
      })
      resultToCompute = uniqBy(resultToCompute, 'pk')
      return this.processSellersDatas(resultToCompute)
    },
    // displayed on tab ACCOUNT
    processedStatsAccounts () {
      let statsSales = this.statsSales.filter(x => x.account && x.account.pk !== this.accountPk)
      const entityNameGenerator = sale => `${sale.account.name}`
      const accountDataList = this.computeEntityData(statsSales, 'account.pk', 'account', entityNameGenerator)
      for (let accountData of accountDataList) {
        const entityNameGenerator = sale => sale.user ? `${sale.user.first_name} ${sale.user.last_name}` : null
        accountData.subEntities = this.computeEntityData(accountData.items, 'user.pk', 'user', entityNameGenerator)
      }
      return this.processSellersDatas(accountDataList)
    },
    // displayed on tab TEAM
    processedStatsTeams () {
      let statsSales = this.statsSales.filter(x => x.manager && x.account && x.account.pk === this.accountPk)
      const entityNameGenerator = sale => `${sale.manager.first_name} ${sale.manager.last_name}`
      const managerDataList = this.computeEntityData(statsSales, 'manager.pk', 'manager', entityNameGenerator)
      for (let managerData of managerDataList) {
        const entityNameGenerator = sale => `${sale.user.first_name} ${sale.user.last_name}`
        managerData.subEntities = this.processSellersDatas(this.computeEntityData(managerData.items, 'user.pk', 'user', entityNameGenerator))
      }
      return this.processSellersDatas(managerDataList)
    },
    // displayed on tab GROUPS
    processedStatsGroups () {
      let statsSales = this.statsSales.filter(x => x.groups.length > 0)
      let entityDict = {}
      for (let sale of statsSales) {
        for (let group of sale.groups) {
          const entityKey = group.name
          const entityKeyExist = Object.hasOwn(entityDict, entityKey)
          if (!entityKeyExist) {
            entityDict[entityKey] = {
              pk: entityKey,
              type: 'group',
              name: group.name,
              items: [],
              subEntities: []
            }
          }
          entityDict[entityKey].items.push(sale)
        }
      }
      const groupDataList = Object.values(entityDict)
      for (let groupData of groupDataList) {
        const entityNameGenerator = sale => `${sale.user.first_name} ${sale.user.last_name}`
        groupData.subEntities = this.processSellersDatas(this.computeEntityData(groupData.items, 'user.pk', 'user', entityNameGenerator))
      }
      return this.processSellersDatas(groupDataList)
    },
    statsEntities () {
      if (this.tab === 'SELLERS') {
        return this.processedStatsSellers
      } else if (this.tab === 'ACCOUNT') {
        return this.processedStatsAccounts
      } else if (this.tab === 'TEAM') {
        return this.processedStatsTeams
      } else if (this.tab === 'GROUPS') {
        return this.processedStatsGroups
      } else if (this.tab === 'SELECTION') {
        return this.processedStatsSellersSelection
      } else {
        return []
      }
    },
    sortedEntities () {
      let items = [...this.statsEntities]
      if (this.hasSort) {
        return items.sort((a, b) => {
          if (this.sortOrder === 'asc') {
            if (typeof a[this.sortKey] === 'number') return a[this.sortKey] - b[this.sortKey]
            else if (a[this.sortKey] && b[this.sortKey]) {
              if (a[this.sortKey].toLowerCase() < b[this.sortKey].toLowerCase()) return -1
              else if (a[this.sortKey].toLowerCase() > b[this.sortKey].toLowerCase()) return 1
              else return 0
            }
          } else {
            if (typeof a[this.sortKey] === 'number') return b[this.sortKey] - a[this.sortKey]
            else if (a[this.sortKey] && b[this.sortKey]) {
              if (a[this.sortKey].toLowerCase() < b[this.sortKey].toLowerCase()) return 1
              else if (a[this.sortKey].toLowerCase() > b[this.sortKey].toLowerCase()) return -1
              else return 0
            }
          }
        })
      } else return items
    },
    totalEntities () {
      let allEntitiesSales = flatten(this.statsEntities.slice().map(x => x.items))
      const total = allEntitiesSales.reduce((a, b) => {
        const sellerCom = b.sale_price_ttc * (b.seller_remuneration / 100)
        const CAImmo = b.sale_price_ttc// * (b.program_remuneration / 100)
        return {
          seller_com: sellerCom ? a.seller_com + Math.floor(sellerCom) : a.seller_com + 0,
          avg_seller_com: a.avg_seller_com + b.seller_remuneration,
          CA_immo: CAImmo ? a.CA_immo + Math.floor(CAImmo) : a.CA_immo + 0
        }
      }, {
        seller_com: 0,
        avg_seller_com: 0,
        CA_immo: 0
      })
      let validSales = allEntitiesSales.length
      return {
        name: 'Synthèse',
        pre_reserved: allEntitiesSales.filter(x => x.status === 'pre_reserved').length,
        reserved: allEntitiesSales.filter(x => x.status === 'reserved').length,
        sold: allEntitiesSales.filter(x => x.status === 'sold').length,
        canceled: allEntitiesSales.filter(x => x.status === 'canceled').length,
        CA_immo: total.CA_immo,
        avg_sale_price: total.CA_immo / validSales,
        seller_com: total.seller_com,
        avg_seller_sale_price: total.seller_com / validSales,
        avg_seller_com: total.avg_seller_com / validSales
      }
    },
    totalSubEntities () {
      if (!this.statsEntities || !this.statsEntities.length) return
      let results = []
      this.statsEntities.slice().forEach(entity => {
        entity.subEntities.forEach(sub => {
          let allEntitiesSales = sub.items
          const total = allEntitiesSales.reduce((a, b) => {
            const sellerCom = b.sale_price_ttc * (b.seller_remuneration / 100)
            const CAImmo = b.sale_price_ttc * (b.program_remuneration / 100)
            return {
              seller_com: sellerCom ? a.seller_com + Math.floor(sellerCom) : a.seller_com + 0,
              avg_seller_com: a.avg_seller_com + b.seller_remuneration,
              CA_immo: CAImmo ? a.CA_immo + Math.floor(CAImmo) : a.CA_immo + 0
            }
          }, {
            seller_com: 0,
            avg_seller_com: 0,
            CA_immo: 0
          })
          let validSales = allEntitiesSales.length
          results.push({
            pk: sub.pk,
            pre_reserved: allEntitiesSales.filter(x => x.status === 'pre_reserved').length,
            reserved: allEntitiesSales.filter(x => x.status === 'reserved').length,
            sold: allEntitiesSales.filter(x => x.status === 'sold').length,
            canceled: allEntitiesSales.filter(x => x.status === 'canceled').length,
            CA_immo: total.CA_immo,
            avg_sale_price: total.CA_immo / validSales,
            seller_com: total.seller_com,
            avg_seller_sale_price: total.seller_com / validSales,
            avg_seller_com: total.avg_seller_com / validSales
          })
        })
      })
      return results
    }
  },
  watch: {
    'sourceStatsSales' (v) {
      this.updateSources({ sales: v })
    },
    quickview ({ mode, params, results }) {
      if (mode === 'USER_SELECTION' && results) {
        this.updateEntitySelection(results.entities)
      }
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.panel) {
      this.tab = this.$route.query.panel
    }
    if (localStorage.getItem('stats_entities_selection')) {
      this.entitiesSelection = JSON.parse(localStorage.getItem('stats_entities_selection'))
    }
  },
  methods: {
    searchNewEntity () {
      let params = {
        searchKeys: ['USER', 'ACCOUNT'],
        facets: {
          USER: [],
          ACCOUNT: []
        },
        mode: 'append'
      }
      this.entitiesSelection.forEach(entity => {
        if (!entity.last_name) {
          params.facets.ACCOUNT.push([`pk:-${entity.pk}`])
        } else {
          params.facets.USER.push([`pk:-${entity.pk}`])
        }
      })
      this.openUserSelectionQuickview(params)
    },
    updateEntitySelection (entities) {
      entities.forEach(entity => {
        this.entitiesSelection.push({
          pk: entity.pk,
          first_name: entity.first_name,
          last_name: entity.last_name,
          name: entity.name
        })
      })
      this.entitiesSelection = uniqBy(this.entitiesSelection, 'pk')
      localStorage.setItem('stats_entities_selection', JSON.stringify(this.entitiesSelection))
      this.$store.commit('closeQuickview')
    },
    removeEntity (entity) {
      let idx = this.entitiesSelection.findIndex(x => {
        return x.pk === entity.pk || x.name === entity.pk || intersection(x.name.split(' '), entity.name.split(' ')).length === entity.name.split(' ').length
      })
      if (idx >= 0) {
        this.entitiesSelection.splice(idx, 1)
        localStorage.setItem('stats_entities_selection', JSON.stringify(this.entitiesSelection))
      }
    },
    clearSelection () {
      localStorage.setItem('stats_entities_selection', [])
      this.entitiesSelection = []
    }
  }
}
</script>
